// extracted by mini-css-extract-plugin
module.exports = {"footerAddition":"BbscX","block":"ei8nv"};